<div>
  <input autocomplete="off"
         (keyup)="searchLocker(lockerInput)"
         type="text"
         #lockerInput="ngModel"
         name="client"
         [(ngModel)]="locker.name"
         [disabled]="disabled"
         class="uk-input"
         required
         #lockerField
         id="searchLockerInput"
  >

  <div style="position: absolute; max-height: 200px;" class="uk-overflow-auto">
    <ul class="uk-list uk-list-divider uk-position-relative uk-margin-remove-top"
        style="background-color: white; width: 100%;"
        *ngIf="lockers.length > 0"
        [style.width]="lockerField.clientWidth + 'px'"
        id="searchLockerOptionList"
    >
      <li *ngFor="let locker of lockers; let i = index"
          (click)="setLocker(locker);"
          style="padding-left: 10px"
          id="searchLockerOptionListElement"
      >{{locker.name}}</li>
    </ul>
  </div>
</div>
